import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    DhcpdConfig,
    DhcpdConfigServer,
    NetworkConnectionProfile,
    NetworkStaticRoutes,
} from "userful-chronos-app-common-js/dist/models/config/networkConnections";
import { PackageStatus } from "./packageStatus";

export interface InitialStateConnection {
    networkConnections: NetworkConnectionProfile[];
    networkInterfaces: StringID[];
    dhcp: DhcpdConfigServer[];
    loadingStatus: boolean;
    dhcpPackageStatus: PackageStatus | null;
}

const initialStateConnection: InitialStateConnection = {
    networkConnections: [],
    networkInterfaces: [],
    dhcp: [],
    loadingStatus: false,
    dhcpPackageStatus: null,
};

export const networkConnectionsSlice = createSlice({
    name: "networkConnectionsSlice",
    initialState: initialStateConnection,
    reducers: {
        setLoadingStatus: (state, action: PayloadAction<boolean>) => {
            state.loadingStatus = action.payload;
        },
        setNetworkInterfaces: (state, action: PayloadAction<StringID[]>) => {
            state.networkInterfaces = action.payload;
        },
        setConnectionData: (state, action: PayloadAction<NetworkConnectionProfile[]>) => {
            state.networkConnections = action.payload;
        },
        setDHCPData: (state, action: PayloadAction<DhcpdConfigServer[]>) => {
            state.dhcp = action.payload;
        },
        addOrUpdateConnection: (state, action: PayloadAction<NetworkConnectionProfile>) => {
            const foundIndex = state.networkConnections.findIndex(
                (item) => item.uuid.value === action.payload.uuid.value,
            );

            if (foundIndex < 0) {
                state.networkConnections = [...state.networkConnections, { ...action.payload }];
            } else {
                state.networkConnections = [
                    ...state.networkConnections.slice(0, foundIndex),
                    { ...action.payload },
                    ...state.networkConnections.slice(foundIndex + 1),
                ];
            }
        },
        updateRoutesConnection: (state, action: PayloadAction<NetworkStaticRoutes>) => {
            const foundIndex = state.networkConnections.findIndex(
                (item) => item.uuid.value === action.payload.connectionUUID.value,
            );

            if (foundIndex < 0) {
                return;
            } else {
                state.networkConnections = [
                    ...state.networkConnections.slice(0, foundIndex),
                    { ...state.networkConnections[foundIndex], routingRoutes: action.payload },
                    ...state.networkConnections.slice(foundIndex + 1),
                ];
            }
        },
        removeConnection: (state, action: PayloadAction<StringID>) => {
            state.networkConnections = state.networkConnections.filter((d) => d.uuid.value !== action.payload.value);
        },
        activateConnection: (state, action: PayloadAction<StringID>) => {
            const foundIndex = state.networkConnections.findIndex((item) => item.uuid.value === action.payload.value);

            if (foundIndex < 0) {
                return;
            } else {
                state.networkConnections = [
                    ...state.networkConnections.slice(0, foundIndex),
                    { ...state.networkConnections[foundIndex], active: true },
                    ...state.networkConnections.slice(foundIndex + 1),
                ];
            }
        },
        setDhcpPackageStatus: (state, action: PayloadAction<PackageStatus | null>) => {
            state.dhcpPackageStatus = action.payload;
        },
    },
});

export const networkConnectionsSliceActions = networkConnectionsSlice.actions;

export default networkConnectionsSlice.reducer;
